<div id="sub-top">
    <div class="img-wrap">
        <img src="/assets/images/recruit.png">
        <h2 data-aos="fade-right" data-aos-duration="2000">
            <strong>아이로브는</strong> 협력하여 도전하는 <br> 진취적인 행보의 인재와 함께 하기를 고대합니다.
        </h2>
    </div>
</div>
<section>
    <article>
            <h1 class="h1">채용알림</h1>
            <div *ngIf="notice" class="list-detail">
                <div class="recruitTitle">
                    <h2>{{notice.title}}</h2>
                    <h3 *ngIf="notice.immediateOpening">상시모집</h3>
                    <h3 *ngIf="!notice.immediateOpening">{{notice.startDate}} ~ {{notice.endDate}}</h3>
                    <div class="button">
                        <button class="list">
                            <a [routerLink]="'/recruit/recruitList'">목록으로</a>
                        </button>
                        <button class="apply">
                            <a (click)="linkTo()" target="_blank">지원하기</a>
                        </button>
                    </div>
                </div>
                <div class="contents">
                    <div class="date">
                        <p>등록일</p>
                        <p>{{notice.creationDate |date: "yyyy-MM-dd"}}</p>
                    </div>
                    <img src="/assets/images/recruitDetail.png">
                    <div class="table">
                        <table>
                            <tr>
                                <th scope="row">업무내용</th>
                                <td >
                                    <li *ngFor="let jobDescription of jobDescriptions">· {{jobDescription}}</li>
                                </td>
                            </tr>
                            <tr>
                                <th scope="row">지원자격</th>
                                <td >
                                    <li *ngFor="let essentialSkill of essentialSkills"> · {{essentialSkill}}</li>
                                </td>
                            </tr>
                            <tr>
                                <th scope="row">우대사항</th>
                                <td >
                                    <li *ngFor="let extraSkill of extraSkills"> · {{extraSkill}}</li>
                                </td>
                            </tr>

                        </table>

                    </div>
                </div>
            </div>
    </article>
</section>